import { getCacheHitRatio, getLighthouseMetrics } from '@atlaskit/react-ufo/additional-payload';
import type { InteractionMetrics } from '@atlaskit/react-ufo/interaction-metrics';
import { getMeta } from '../../meta';
import { getMarks } from '../marks';
import { getPageSizeInfo, getExtraNavigationTimings, getPageSizeMetrics } from '../page-size';

export function getHelpCenterCustomData(interaction: InteractionMetrics) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData: Record<string, any> = {};

    const region = getMeta('ajs-region');

    if (region !== null && region !== '') {
        customData.region = region;
    }

    customData.httpProtocol =
        (performance.getEntriesByType('resource') as PerformanceResourceTiming[]).find(
            ({ nextHopProtocol }) => !!nextHopProtocol
        )?.nextHopProtocol ?? 'unknown';

    const { start, end, apdex } = interaction;

    const stop = apdex?.[0]?.stopTime ?? end;

    const lightHouseMetrics = getLighthouseMetrics({
        start,
        stop,
    });

    customData = {
        ...customData,
        ...lightHouseMetrics,
    };

    if (interaction.type === 'page_load') {
        customData = {
            ...customData,
            ...getMarks({ start }),
            ...getPageSizeMetrics(),
            ...getExtraNavigationTimings(),
            ...getPageSizeInfo({ start, stop }),
            ...getCacheHitRatio({ start }),
            'app:version:web': window.BUILD_KEY,
            'app:framework:name': 'react',
        };
    }

    return customData;
}
